import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";

moment.locale("es");

const facturaCompraPdf = (values, tipoFactura) => {
  const empresa = values.respuestaFactura.empresa;
  const dataSat = values.respuestaFactura.dataSat;

  const conceptos = dataSat.Conceptos.map((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
      }
      return null;
    });

    return [
      { style: "textoTablaChico", text: index + 1, alignment: "center" },
      {
        style: "textoTablaChico",
        text: valueConcepto.Cantidad,
        alignment: "right",
      },
      {
        text: valueConcepto.ClaveInt,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.ClaveProv,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.ClaveUnidad,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text:
          valueConcepto.Descripcion +
          (valueConcepto.Observaciones
            ? "\n" + valueConcepto.Observaciones
            : ""),
        style: "textoTablaChico",
        alignment: "left",
      },
      {
        stack: [
          {
            text: dineroDisabledMask(valueConcepto.ValorUnitario),
            style: "textoTablaChico",
            alignment: "right",
          },
          ...(Number(valueConcepto.Descuento) > 0
            ? [
                {
                  text: "Desc: " + dineroDisabledMask(valueConcepto.Descuento),
                  style: "descuentoPartida",
                  alignment: "right",
                },
              ]
            : []),
        ],
      },
      {
        text: dineroDisabledMask(iva),
        style: "textoTablaChico",
        alignment: "right",
      },
      ...(empresa.imprimirIEPS
        ? [
            {
              text: dineroDisabledMask(ieps),
              style: "textoTablaChico",
              alignment: "right",
            },
          ]
        : []),
      {
        text: dineroDisabledMask(valueConcepto.Importe),
        style: "textoTablaChico",
        alignment: "right",
      },
    ];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [
        ...dataSat.Impuestos.Traslados,
        ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.[
          "implocal:TrasladosLocales"
        ] || []),
      ]
    : [
        ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.[
          "implocal:TrasladosLocales"
        ] || []),
      ];

  const impuestosTotales = nuevoArrayImpFL.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre =
        valueImpuesto.Impuesto === "002"
          ? "IVA"
          : valueImpuesto.Impuesto === "003"
            ? "IEPS"
            : valueImpuesto["@ImpLocTrasladado"];
      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre += " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      }
      let border = indexImpuesto + 1 === nuevoArrayImpFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(
            valueImpuesto.Importe || valueImpuesto["@Importe"] || 0,
          ),
          style: "textoChico",
          alignment: "right",
        },
      ];
    },
  );

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [
        ...dataSat.Impuestos.Retenciones,
        ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.[
          "implocal:RetencionesLocales"
        ] || []),
      ]
    : [
        ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.[
          "implocal:RetencionesLocales"
        ] || []),
      ];

  const retencionesTotales = nuevoArrayRetFL.map(
    (valueRetencion, indexRetencion) => {
      let nombre =
        valueRetencion.Impuesto === "001"
          ? "Retención ISR"
          : valueRetencion.Impuesto === "002"
            ? "Retención IVA"
            : valueRetencion["@ImpLocRetenido"];
      let border = indexRetencion + 1 === nuevoArrayRetFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(
            valueRetencion.Importe || valueRetencion["@Importe"] || 0,
          ),
          style: "textoChico",
          alignment: "right",
        },
      ];
    },
  );

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
      (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.[
        "@TotaldeTraslados"
      ] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
      (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.[
        "@TotaldeRetenciones"
      ] || 0) || 0;
  const totalConImpuestos = dataSat.SubTotal - dataSat.Descuento + totalImpFL;

  return {
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          body: [
            [
              {
                image: "logo",
                fit: [80, 80],
                border: [false, false, false, false],
              },
              {
                stack: [
                  {
                    text: empresa.nombreComercial || empresa.nombre,
                    style: "tableHeader",
                  },
                  {
                    text: "R.F.C: " + empresa.rfc,
                    style: "textoChico",
                    alignment: "center",
                  },
                  {
                    text: empresa.calle + " " + empresa.numeroCalle,
                    style: "textoChico",
                    alignment: "center",
                  },
                  {
                    text:
                      empresa.colonia.nombre + " C.P. " + empresa.colonia.cp,
                    style: "textoChico",
                    alignment: "center",
                  },
                  {
                    text:
                      "Regimen Fiscal: " + empresa.regimenFiscal?.descripcion,
                    style: "textoChico",
                    alignment: "center",
                  },
                ],
                border: [false, false, false, false],
              },
              {
                stack: [
                  {
                    text: tipoFactura === "Caja Chica" ? "FACTURA CAJA CHICA" : tipoFactura === "Sin Orden de Compra" ? "FACTURA SIN ORDEN DE COMPRA" : "FACTURA CON ORDEN DE COMPRA",
                    style: "subheader",
                    alignment: "center",
                  },
                  {
                    text:
                    (dataSat.Serie ? dataSat.Serie : "FCC") +
                    " - " +
                    dataSat.Folio,
                    style: "textoChico",
                    alignment: "center",
                  },
                  ...(dataSat?.folioOc
                  ? [
                      {
                        text: "ORDEN DE COMPRA",
                        style: "subheader",
                        alignment: "center",
                        margin: [0, 5, 0, 0], 
                      },
                      {
                        text: dataSat.folioOc,
                        style: "textoChico",
                        alignment: "center",
                      }
                    ]
                  : []),
                  { text: "Moneda:", style: "subheader", alignment: "center" },
                  {
                    text: dataSat.Moneda,
                    style: "textoChico",
                    alignment: "center",
                  },
                ],
                border: [false, false, false, false],
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        text:
          `Factura ${tipoFactura} N° ` +
          (dataSat.Serie ? dataSat.Serie : "FCC") +
          " - " +
          dataSat.Folio,
        style: "tableHeaderIzquierda",
      },

      // BLOQUE DE DATOS DE PROVEEDORES (RECTANGULO SOLICITADO)
      {
        style: "tableExample",
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  body: [
                    [
                      { text: "Nombre del proveedor :", style: "subheader" },
                      { text: dataSat.Receptor.Nombre, style: "textoChico" },
                    ],
                    [
                      { text: "RFC Proveedor:", style: "subheader" },
                      { text: dataSat.Receptor.Rfc, style: "textoChico" },
                    ],
                    [
                      { text: "Fecha:", style: "subheader" },
                      {
                        text: moment(dataSat.Fecha).format("LL"),
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Lugar de expedicion:", style: "subheader" },
                      { text: dataSat.LugarExpedicion, style: "textoChico" },
                    ],
                  ],
                },
                layout: "noBorders",
              },
              {
                table: {
                  widths: ["40%", "60%"],
                  body: [
                    [
                      { text: "UUID :", style: "subheader" },
                      {
                        text: dataSat.uuid || "",
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Direccion de Entrega :", style: "subheader" },
                      {
                        text: dataSat.DireccionEntrega || "",
                        style: "textoChico",
                      },
                    ],
                    ...(dataSat?.usoDeCfdi
                      ? [[
                          { text: "Uso de CFDI:", style: "subheader" },
                          { text: dataSat.usoDeCfdi, style: "textoChico" },
                        ]]
                      : []),
                    ...(dataSat?.formaDePago
                      ? [[
                          { text: "Forma de Pago:", style: "subheader" },
                          { text: dataSat.formaDePago, style: "textoChico" },
                        ]]
                      : []),
                    ...(dataSat?.metodoPago
                      ? [[
                          { text: "Método de Pago:", style: "subheader" },
                          { text: dataSat.metodoPago, style: "textoChico" },
                        ]]
                      : []),
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: {
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineWidth: () => 1,
          vLineWidth: () => 1,
        },
      },

      // TABLA DE CONCEPTOS (CON ESTILO PUNTEADO)
      {
        style: "tableExample",
        table: {
          widths: [
            "2%",
            "8%",
            "10%",
            "10%",
            "10%",
            empresa.imprimirIEPS ? "26%" : "34%",
            "8%",
            "8%",
            ...(empresa.imprimirIEPS ? ["8%"] : []),
            "10%",
          ],
          body: [
            [
              { text: "", style: "tituloTabla" },
              { text: "Cantidad", style: "tituloTabla" },
              { text: "Clave Int.", style: "tituloTabla" },
              { text: "Clave Prov.", style: "tituloTabla" },
              { text: "Unidad", style: "tituloTabla" },
              { text: "Descripción", style: "tituloTabla" },
              { text: "P/U", style: "tituloTabla" },
              { text: "IVA", style: "tituloTabla" },
              ...(empresa.imprimirIEPS
                ? [{ text: "IEPS", style: "tituloTabla" }]
                : []),
              { text: "Importe", style: "tituloTabla" },
            ],
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff"),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineStyle: (i, node) =>
            i === 0 || i === node.table.body.length
              ? null
              : { dash: { length: 2, space: 1 } },
          vLineStyle: (i, node) =>
            i === 0 || i === node.table.widths.length
              ? null
              : { dash: { length: 2 } },
        },
      },

      // TOTALES
      {
        style: "tablaSinMargen",
        table: {
          widths: ["70%", "30%"],
          body: [
            [
              { text: "" },
              {
                table: {
                  widths: ["40%", "60%"],
                  body: [
                    [
                      {
                        text: "Subtotal:",
                        style: "subheader",
                        border: [true, true, false, false],
                      },
                      {
                        text: dineroDisabledMask(dataSat.SubTotal),
                        style: "textoChico",
                        alignment: "right",
                        border: [false, true, true, false],
                      },
                    ],
                    [
                      {
                        text: "Descuento:",
                        style: "subheader",
                        border: [true, false, false, false],
                      },
                      {
                        text: "- " + dineroDisabledMask(dataSat.Descuento),
                        style: "textoChico",
                        alignment: "right",
                        border: [false, false, true, false],
                      },
                    ],
                    ...impuestosTotales,
                    [
                      {
                        text: "TOTAL:",
                        style: "header",
                        fillColor: "#e8e8e8",
                        border: [true, false, false, true],
                      },
                      {
                        text: dineroDisabledMask(totalConImpuestos),
                        style: "header",
                        alignment: "right",
                        fillColor: "#e8e8e8",
                        border: [false, false, true, true],
                      },
                    ],
                    ...retencionesTotales,
                    ...(totalRetFL > 0
                      ? [
                          [
                            {
                              text: "TOTAL PAGO:",
                              style: "header",
                              fillColor: "#e8e8e8",
                              border: [true, false, false, true],
                            },
                            {
                              text: dineroDisabledMask(dataSat.Total),
                              style: "header",
                              fillColor: "#e8e8e8",
                              alignment: "right",
                              border: [false, false, true, true],
                            },
                          ],
                        ]
                      : []),
                  ],
                },
                layout: {
                  hLineColor: () => "#adaaaa",
                  vLineColor: () => "#adaaaa",
                  hLineStyle: (i, node) =>
                    i === 0 || i === node.table.body.length
                      ? null
                      : { dash: { length: 2, space: 1 } },
                  vLineStyle: (i, node) =>
                    i === 0 || i === node.table.widths.length
                      ? null
                      : { dash: { length: 2 } },
                },
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
    images: { logo: empresa.logo.base64Completa },
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: { fontSize: 8 },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        alignment: "center",
        border: true,
      },
      textoTablaChico: { fontSize: 6, italics: false },
      descuentoPartida: { fontSize: 5, color: "#777" },
    },
    pageSize: "LETTER",
  };
};

export default facturaCompraPdf;
